import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9my9ks3re: FaireProductEntity = {
  token: "p_f9my9ks3re",
  type: "product",
  name: "Budvase made with Pressed flower handmade (Custom available)",
  brandToken: "b_7j6yttrrz2",
  brandName: "Tara Kothari",
  imageUrl:
    "https://cdn.faire.com/fastly/cdd95f0c7d02f49ea3418a580ef7977d47cce3b07d0e2b43b4b8a3376eee4a8f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7473468a5ce07bec4b901c91360faa18bc6efb629e19610b2ee426b0164d52f8.jpeg",
    "https://cdn.faire.com/fastly/332d6f792ea3a9361b37c8a787619308eadd76d735f653b707afea498d6338b3.jpeg",
    "https://cdn.faire.com/fastly/628b8e822d800e0fc9a98c1a6f9780f179efb64d5a2e4b4f61f4a7a368362650.jpeg",
    "https://cdn.faire.com/fastly/d6af3a05f5ada61f5a35c064bffa11e93f99d3dbd09f3aec51e91a1af86b50a7.jpeg",
    "https://cdn.faire.com/fastly/da0852c2952c9d3dfefecc6c9872e58eac402482397002f5cb4c48cb3bae1929.jpeg",
    "https://cdn.faire.com/fastly/d06b3fa6b4a2a2f39bc54ed35e523c0f446056d958b74f58f1cdbdb4237bc308.jpeg",
    "https://cdn.faire.com/fastly/316712bcbb39b8ba4a72bd416e37dfe00ccd549199b3c639ba99fe9c786fe387.jpeg",
    "https://cdn.faire.com/fastly/7a1aa8aece0ed1ffdd8dff173b6efe4c10698bce1efa83c1d80ef4fcd1ffbdc6.jpeg",
    "https://cdn.faire.com/fastly/b40ba8d6b27d78dcbf5140a9a01feda02647a51c8a9eaa328b92b7c4d2fe9ea8.jpeg",
  ],
  priceDollars: 28.76,
  description:
    "A delightful handmade budvase  made with pressed flowers in clay & hand painted. \nI have two options- one for budvases where i source the flowers. \nThe other is where you send me flowers from botanical gardens/ musuem grounds, your town/ city and I create bud vases with that. Minimum order for custom flowers is 24. \n\nEach piece is made by hand and has real flowers pressed in clay along . Every piece is unique & varies not only because it is hand made, but because it has unique flowers pressed in and individually hand painted. \n\nHandmade using stoneware clay. \nAll dishes are one of a kind and all slightly unique, colors may slightly vary. \n\nDimensions ~ 2.5”x 1.25” x 1.25”\n~ 4oz capacity\n\nNOTE 1- Flowers will be assorted by season. If you are particular, please send a note checking with me before placing order and I will do my best to accommodate. ",
  tags: [],
  msrpDollars: 57.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:44.025Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
